import React, { FC } from 'react';
import classNames from 'classnames';

import { Icon } from 'app/design-system/components/Icon';

import { ICON_NAME_ARROW_RIGHT } from '../../constants/IconNames';
import { ArrowSize } from '../../types/ArrowDivider';
import type { IconName } from '../../types/Icon';

import styles from './ArrowDivider.module.scss';

export { ArrowSize };
export type ArrowDividerProps = {
  icon?: IconName;
  size?: ArrowSize;
  className?: string;
};

export const ArrowDivider: FC<ArrowDividerProps> = ({
  icon,
  size = ArrowSize.DEFAULT as number,
  className,
}) => {
  return (
    <span className={styles.wrapper}>
      <Icon className={classNames(styles.icon, className)}
            icon={icon || ICON_NAME_ARROW_RIGHT}
            size={size} />
    </span>
  );
};
